import AxiosService from "@/services/AxiosService";

const JOB_ENDPOINT = "/api/v1/jobs";

export default class JobService {

  constructor() {
    this.service = new AxiosService();
  }

  resolveJobs() {
    return this.service.get(JOB_ENDPOINT);
  }
}